import React, { useState } from "react";
import { getOrdersRegisterReport } from "../../../services/apiService";

const OrdersRegisterReport = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filter, setFilter] = useState("All Orders");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ---------- FETCH REPORT ---------- */
  const handleSearch = async () => {
    try {
      setLoading(true);
      const res = await getOrdersRegisterReport(fromDate, toDate);

      const successOrders = (res?.success || []).map((item) => ({
        ...item,
        orderstatus: "Success",
      }));

      const cancelOrders = (res?.cancel || []).map((item) => ({
        ...item,
        orderstatus: "Cancel",
      }));

      // Merge & Sort by latest date
      const mergedData = [...successOrders, ...cancelOrders].sort(
        (a, b) => new Date(b.orderdate) - new Date(a.orderdate)
      );

      setData(mergedData);
    } catch (error) {
      console.error("Report Error:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  /* ---------- FILTER LOGIC ---------- */
  const filteredData = data.filter((item) => {
    if (filter === "Success Orders") return item.orderstatus === "Success";
    if (filter === "Cancel Orders") return item.orderstatus === "Cancel";
    return true;
  });

  /* ---------- FORMAT DATE ---------- */
  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  /* ---------- TOTALS ---------- */
  const successTotal = data
    .filter((item) => item.orderstatus === "Success")
    .reduce((sum, item) => sum + Number(item.total || 0), 0);

  const cancelTotal = data
    .filter((item) => item.orderstatus === "Cancel")
    .reduce((sum, item) => sum + Number(item.total || 0), 0);

  return (
    <div style={styles.wrapper}>
      {/* ---------- FILTER BAR ---------- */}
      <div style={styles.filterRow}>
        <div>
          <label>From:&nbsp;</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div>
          <label>To:&nbsp;</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <button style={styles.searchBtn} onClick={handleSearch}>
          Search
        </button>
      </div>

      <div style={{ marginBottom: "10px" }}>
        <label>Filter:&nbsp;</label>
        <select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option>All Orders</option>
          <option>Success Orders</option>
          <option>Cancel Orders</option>
        </select>
      </div>

      {/* ---------- TABLE ---------- */}
      <div style={styles.tableBox}>
        <table style={styles.table}>
          <thead>
            <tr style={styles.thead}>
              <th style={styles.th}>Order ID</th>
              <th style={styles.th}>Customer</th>
              <th style={styles.th}>Mobile</th>
              <th style={styles.th}>Total</th>
              <th style={styles.th}>Order Date</th>
              <th style={styles.th}>Status</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" style={styles.noData}>
                  Loading...
                </td>
              </tr>
            ) : filteredData.length === 0 ? (
              <tr>
                <td colSpan="6" style={styles.noData}>
                  No Data Found
                </td>
              </tr>
            ) : (
              filteredData.map((row, index) => (
                <tr
                  key={row.orderid}
                  style={{
                    background: index % 2 === 0 ? "#f8f9fa" : "#fff",
                  }}
                >
                  <td style={styles.td}>{row.orderid}</td>
                  <td style={styles.td}>
                    {row.customer_details?.[0]?.first_name || "-"}
                  </td>
                  <td style={styles.td}>
                    {row.customer_details?.[0]?.mobile || "-"}
                  </td>
                  <td style={styles.td}>
                    ₹
                    {Number(row.total || 0).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                    })}
                  </td>
                  <td style={styles.td}>{formatDate(row.orderdate)}</td>
                  <td style={styles.td}>
                    <span
                      style={{
                        ...styles.status,
                        background:
                          row.orderstatus === "Success"
                            ? "#198754"
                            : "#dc3545",
                      }}
                    >
                      {row.orderstatus}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ---------- GRAND TOTALS ---------- */}
      <div style={styles.totalWrapper}>
        <div style={styles.successTotal}>
          <strong>Success Grand Total:</strong> ₹
          {successTotal.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
          })}
        </div>

        <div style={styles.cancelTotal}>
          <strong>Cancel Grand Total:</strong> ₹
          {cancelTotal.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
          })}
        </div>
      </div>
    </div>
  );
};

export default OrdersRegisterReport;


/* ---------- STYLES (VERY IMPORTANT) ---------- */
const styles = {
  wrapper: {
    background: "#fff",
    padding: "15px",
    borderRadius: "6px",
  },
  filterRow: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    marginBottom: "10px",
  },
  searchBtn: {
    background: "#198754",
    color: "#fff",
    border: "none",
    padding: "6px 14px",
    cursor: "pointer",
    borderRadius: "4px",
  },
  tableBox: {
    border: "1px solid #ddd",
    borderRadius: "6px",
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  thead: {
    background: "#212529",
    color: "#fff",
  },
  th: {
    padding: "10px",
    fontSize: "13px",
    textAlign: "left",
    color:"white"
  },
  td: {
    padding: "10px",
    fontSize: "13px",
    borderBottom: "1px solid #e5e5e5",
  },
  noData: {
    padding: "20px",
    textAlign: "center",
  },
  status: {
    color: "#fff",
    padding: "3px 10px",
    borderRadius: "12px",
    fontSize: "12px",
  },
  totalWrapper: {
  marginTop: "15px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
},

successTotal: {
  background: "#d1e7dd",
  border: "1px solid #badbcc",
  color: "#0f5132",
  padding: "12px",
  borderRadius: "6px",
  fontSize: "14px",
},

cancelTotal: {
  background: "#f8d7da",
  border: "1px solid #f5c2c7",
  color: "#842029",
  padding: "12px",
  borderRadius: "6px",
  fontSize: "14px",
},

};
